var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 18.539q-2.091 0-3.545-1.435Q2 15.67 2 13.608q0-1.725 1.08-3.07a4.8 4.8 0 0 1 2.784-1.726q.067-.18.136-.348.067-.168.136-.37L3 5.002a.84.84 0 0 1-.25-.628q0-.381.25-.627a.87.87 0 0 1 .636-.247q.387 0 .637.247l15.454 15.24a.87.87 0 0 1 .262.616.83.83 0 0 1-.262.639.9.9 0 0 1-.625.258.9.9 0 0 1-.648-.236l-1.772-1.726zm0-1.794h7.864L7.545 9.53q-.045.246-.068.47a5 5 0 0 0-.022.471H7q-1.319 0-2.25.919a3 3 0 0 0-.932 2.219q0 1.3.932 2.219a3.09 3.09 0 0 0 2.25.918m13.727.673-1.318-1.255q.386-.314.58-.729.192-.414.193-.93 0-.941-.66-1.591-.658-.65-1.613-.65h-1.363V10.47q0-1.86-1.33-3.171Q13.887 5.988 12 5.988q-.614 0-1.182.145-.568.146-1.09.46l-1.319-1.3a6.4 6.4 0 0 1 1.693-.818A6.3 6.3 0 0 1 12 4.195q2.66 0 4.511 1.826 1.853 1.827 1.853 4.45 1.567.178 2.602 1.333t1.034 2.7q0 .875-.34 1.625-.342.75-.933 1.289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOffOutline);
export default __webpack_public_path__ + "static/media/cloud_off_outline.e94967d3ef167ffbd942497dad9665d9.svg";
export { ForwardRef as ReactComponent };